import { render, staticRenderFns } from "./AgregarDetalle.vue?vue&type=template&id=61e69ae4&scoped=true"
import script from "./AgregarDetalle.vue?vue&type=script&lang=ts"
export * from "./AgregarDetalle.vue?vue&type=script&lang=ts"
import style0 from "./AgregarDetalle.vue?vue&type=style&index=0&id=61e69ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e69ae4",
  null
  
)

export default component.exports